import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { parseSegments, findLabel } from "./utils"
import MergeTagPillDisplay from "./MergeTagPillDisplay"

type Props = {
  text: string
  fontWeight?: string | number
  lineHeight?: string
  pillSize?: "sm" | "md" | "lg"
}

const MergeTagTextPreview = ({
  text,
  fontWeight = "semibold",
  lineHeight = "2.5rem",
  pillSize = "md",
}: Props) => {
  if (!text) return null

  const segments = parseSegments(text)
  const hasTags = segments.some((segment) => segment.type === "tag")

  if (!hasTags) {
    return <Text as="span" fontWeight={fontWeight} lineHeight={lineHeight}>{text}</Text>
  }

  return (
    <Box as="span" display="inline" fontWeight={fontWeight} lineHeight={lineHeight}>
      {segments.map((segment, index) => {
        if (segment.type === "text") {
          return (
            <Text as="span" key={index} whiteSpace="pre-wrap">
              {segment.value}
            </Text>
          )
        }

        const label = findLabel(segment.value, [])

        return (
          <Box
            as="span"
            key={index}
            display="inline"
            verticalAlign="middle"
          >
            <MergeTagPillDisplay
              tagLabel={label}
              variant="selectable"
              size={pillSize}
              readOnly
            />
          </Box>
        )
      })}
    </Box>
  )
}

export default MergeTagTextPreview
